<ul sd-list-block>
  @for (data of dataToasterList(); track data.id) {
    <li class="toaster-div">
      <sd-toaster [toasterData]="data.toaster" />
    </li>
  }
</ul>
